module.exports = __webpack_public_path__ + "img/benoit20.64c590c7.jpg";